import MuiDivider, {
  DividerProps as MuiDividerProps,
} from '@mui/material/Divider';

interface DividerProps extends MuiDividerProps {
  light?: boolean;
}

export const Divider: React.FC<DividerProps> = ({
  light = false,
  sx,
  ...props
}) => {
  return (
    <MuiDivider
      {...props}
      sx={[{ opacity: light ? 0.5 : 1 }, ...(Array.isArray(sx) ? sx : [sx])]}
    ></MuiDivider>
  );
};
